var loadAsyncJS;

module.exports = loadAsyncJS = function(url) {
  var p, s;
  s = document.createElement('script');
  s.async = true;
  s.src = url;
  p = document.getElementsByTagName('script')[0];
  return p.parentNode.insertBefore(s, p);
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL2NvcmUvZnJvbnRlbmQvZ3JvdXBvbl9tb2R1bGVzL2xvYWRBc3luY0pTLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9za2ltL3Nscy9jb3JlL2Zyb250ZW5kL2dyb3Vwb25fbW9kdWxlcy9sb2FkQXN5bmNKUy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsSUFBQTs7QUFBQSxNQUFNLENBQUMsT0FBUCxHQUFpQixXQUFBLEdBQWMsU0FBQyxHQUFEO0FBQzdCLE1BQUE7RUFBQSxDQUFBLEdBQUksUUFBUSxDQUFDLGFBQVQsQ0FBdUIsUUFBdkI7RUFDSixDQUFDLENBQUMsS0FBRixHQUFVO0VBQ1YsQ0FBQyxDQUFDLEdBQUYsR0FBUTtFQUNSLENBQUEsR0FBSSxRQUFRLENBQUMsb0JBQVQsQ0FBOEIsUUFBOUIsQ0FBd0MsQ0FBQSxDQUFBO1NBQzVDLENBQUMsQ0FBQyxVQUFVLENBQUMsWUFBYixDQUEwQixDQUExQixFQUE2QixDQUE3QjtBQUw2QiJ9
